/* tslint:disable */
/* eslint-disable */
/**
 * My Title
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PartLocationResponse
 */
export interface PartLocationResponse {
    /**
     * 
     * @type {number}
     * @memberof PartLocationResponse
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof PartLocationResponse
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof PartLocationResponse
     */
    description?: string;
}

/**
 * Check if a given object implements the PartLocationResponse interface.
 */
export function instanceOfPartLocationResponse(value: object): value is PartLocationResponse {
    return true;
}

export function PartLocationResponseFromJSON(json: any): PartLocationResponse {
    return PartLocationResponseFromJSONTyped(json, false);
}

export function PartLocationResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PartLocationResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'description': json['description'] == null ? undefined : json['description'],
    };
}

export function PartLocationResponseToJSON(json: any): PartLocationResponse {
    return PartLocationResponseToJSONTyped(json, false);
}

export function PartLocationResponseToJSONTyped(value?: PartLocationResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'description': value['description'],
    };
}

